import { jsx } from 'react/jsx-runtime';
import classNames from 'classnames';
import style from '../ProductPrice.module.scss.js';

const Amount = ({ children, className, isPriceBold = true, isReducedPrice, price, ...otherProps }) => (jsx("span", { className: classNames(style['z-product-price__amount'], className, {
        [style['z-product-price__amount--weight-normal']]: !isPriceBold,
        [style['z-product-price__amount--reduced']]: isReducedPrice,
    }), ...otherProps, children: children || price }));
Amount.displayName = 'Amount';

export { Amount };
//# sourceMappingURL=Amount.js.map
